import api from '@/api/api';

export default {

  namespaced: true,

  state: {
    infoEnvio: {
      dimensiones: {
        alto: '',
        largo: '',
        ancho: '',
      },
    },
    infoEnvioGeneradaDespues:{
      
    },
    guiasAgregadasDespues:[]
    
  },
  mutations: {
    chargeinfoEnvio(state, datos) {
      state.infoEnvio = datos;
    },
    chargeInfoEnvioGeneradaDespues(state, datos) {
      state.infoEnvioGeneradaDespues = datos;
    },
    chargeGuiasAgregadasDespues(state,datos){
      state.guiasAgregadasDespues = datos;
    },
    
    destroyinfoEnvioGeneradaDespues(state) {
      state.infoEnvioGeneradaDespues = {}
    },
    destroyStoreInfoEnvio(state) {
      state.guiasAgregadasDespues = [],
      state.infoEnvioGeneradaDespues = {},
      state.infoEnvio = {
        dimensiones: {
          alto: '',
          largo: '',
          ancho: '',
        },
      };
    },
  },
  actions: {
    async destroyStoreInfoEnvio({ commit }) {
      commit('destroyStoreInfoEnvio');
      commit('abonosEnvios/destroyStoreAbonosEnvios', '', { root: true });
    },
    async chargeinfoEnvio({ commit }, infoEnvio) {
      commit('chargeinfoEnvio', infoEnvio);
    },
    chargeInfoEnvioGeneradaDespues({ commit }, infoEnvioGD) {
      commit('chargeInfoEnvioGeneradaDespues', infoEnvioGD);
    },
    chargeGuiasAgregadasDespues({ commit }, guiasDespues) {
      commit('chargeGuiasAgregadasDespues', guiasDespues);
    },
   
    async destroyinfoEnvioGeneradaDespues({ commit }) {
      commit('destroyinfoEnvioGeneradaDespues');
    },
  },
};
